import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

const lineV = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.1, ease: EASE, delay: i * 0.12 } }),
};

export const MaskLines = ({ lines, className = "", onLoad = false, delay = 0 }) => {
  const trigger = onLoad
    ? { initial: "hidden", animate: "show" }
    : { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <motion.span {...trigger} className={`block ${className}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span custom={i + delay / 0.12} variants={lineV} className="block will-change-transform">
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", as = "div" }) => {
  const C = motion[as];
  return (
    <C
      initial={{ opacity: 0, y: 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      className={className}
    >
      {children}
    </C>
  );
};

export const Overline = ({ children, className = "" }) => (
  <p className={`font-mono text-[11px] sm:text-xs uppercase tracking-[0.3em] text-gold ${className}`}>
    <span className="inline-block w-8 h-px bg-gold/70 align-middle mr-3" />
    {children}
  </p>
);
